export const projectQueryKeys = {
  GET_PROJECT_QUERY: 'getProjectQuery',
  GET_FOLDER_BY_ID: 'getFolderById',
  GET_PROJECT_FOLDER_QUERY: 'getProjectFolderQuery',
  GET_PROJECT_TREE_QUERY: 'getProjectTreeQuery',
  GET_MY_PROJECTS_QUERY: 'getMyProjectsQuery',
  GET_PROJECT_LIMIT_QUERY: 'getProjectLimitQuery',
  GET_PROJECT_PATH_QUERY: 'getProjectPathQuery'
}

export const projectMutationKeys = {
  CREATE_PROJECT: 'createProject',
  SET_MEMBER_ROLE_IN_PROJECT: 'setMemberRoleInProject',
  UPDATE_PROJECT_MUTATION: 'updateProjectMutation',
  UPDATE_PROJECTS_BATCH_MUTATION: 'updateProjectsBatchMutation',
  USER_LEAVE_PROJECT_MUTATION: 'userLeaveProjectMutation',
  UPDATE_PROJECT_FOLDER_MUTATION: 'updateProjectFolderMutation',
  CREATE_FOLDER: 'createFolder',
  MOVE_PROJECT_AND_FOLDERS: 'moveProjectAndFolders',
  DELETE_FOLDER_MUTATION: 'deleteFolderMutation',
  COPY_PROJECT_MUTATION: 'copyProjectMutation',
  CHECK_CHILDREN_NAME_IS_AVAILABLE: 'checkChildrenNameIsAvailable'
}

export const permissionParamOptionos = {
  CATEGORIES: 'Categories',
  PERMISSIONS: 'Permissions',
  LAST_MODIFIED: 'LastModified',
  NUMBER_OF_PLANS: 'NumberOfPlans'
}
